const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    width: {
      size: "CONTENT"
    },
    alignment: "CENTER",
    textWrap: true
  }
});

export { DEFAULTS, RICOS_DEFAULTS };
//# sourceMappingURL=defaults.js.map
